<div class="page">
	<div class="header">
		<span>{{fileName}}</span>

		<ng-container *ngIf="(isCloseDisabled && isMobileDevice) || isCloseEnabled">
			<mat-button-toggle class="toggle-slide" (change)="closeSlide()">
				<mat-icon>close</mat-icon>
			</mat-button-toggle>
		</ng-container>
	</div>

	<app-loader *ngIf="!documentDetails || isDocumentLoading || isLoading" [isLoadingFailed]="isLoadingFailed"
		[loaderMessage]="loaderMessage" [matIconFailed]="'image_not_supported'"></app-loader>
		
	<div #viewer class="viewer">
		<div class="document-loading" *ngIf="!isViewerReady">
			<p>Loading document...</p>
		</div>
	</div>
</div>